import Skeleton from 'react-loading-skeleton';
import React from 'react';

export const BalanceControllerLoader = () => (
  <div className='flex flex-col items-center justify-center gap-4'>
    <Skeleton width='146px' height='48px' />
    <Skeleton width='160px' height='21px' />
    <Skeleton width='400px' height='41px' />
  </div>
);
